import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=70236b56"
import script from "./PostList.vue?vue&type=script&lang=ts"
export * from "./PostList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports